import { useState, createContext, useCallback, useContext, useRef } from 'react'
import { BaseConfigContext } from './BaseConfig'
import _ from 'lodash'

export const InsertContext = createContext({})

// 插入到画布中的插件
const InsertProvider = ({ children }) => {
    const { maxSize } = useContext(BaseConfigContext)
    const [insertList, setInsertList] = useState([])
    const [currentPlugin, setCurrentPlugin] = useState({})
    const _currentInsertPlugin = useRef({})

    const _handleSetCurrentPlugin = useCallback(() => {
        setCurrentPlugin(_currentInsertPlugin.current)
    }, [])

    const initInsertProvider = () => {
        setCurrentPlugin({})
        setInsertList([])
        _currentInsertPlugin.current = {}
    }

    const handleChangeCurrentPluginRect = useCallback(({
        width,
        height,
        left,
        top,
    }, target = 0) => {
        // target为0修改自身属性 大于0修改子插件属性
        let rect = target === 0 ? _currentInsertPlugin.current.rectOptions : _currentInsertPlugin.current.rectOptions.subRectOptions[target - 1]
        rect.width = Math.min(width ? width : rect.width, maxSize.width)
        rect.height = Math.min(height ? height: rect.height, maxSize.height)
        rect.left = left !== undefined ? left : rect.left
        rect.top = top !== undefined ? top : rect.top
        setCurrentPlugin(_.cloneDeep( _currentInsertPlugin.current))
        updateCurPluginFromList()
    }, [currentPlugin])

    const handleUpdatePluginProps = useCallback((newProps = {}, target = 0) => {
        let props = target === 0 ? _currentInsertPlugin.current.props : _currentInsertPlugin.current.props.subProps[target - 1]
        props = Object.assign(props, newProps)
        setCurrentPlugin(_.cloneDeep(_currentInsertPlugin.current))
        updateCurPluginFromList()
    }, [currentPlugin])

    const updateCurPluginFromList = useCallback(() => {
        const newList = [...insertList]
        newList.forEach((item, index) => {
            if (item.insertId === _currentInsertPlugin.current.insertId) {
                newList[index] = _currentInsertPlugin.current
                setInsertList(newList)
            }
        })
    }, [insertList])

    const insert = useCallback((plugin) => {
        const newPlugin = Object.assign({}, plugin)
        const newList = [...insertList]
        newPlugin.insertId = Date.now() + ''
        newList.push(newPlugin)
        setInsertList(newList)
        _currentInsertPlugin.current = newPlugin
        _handleSetCurrentPlugin()
    }, [insertList])

    const exchangePluginOrder = useCallback((o, t) => {
        const newList = [...insertList]
        const m = newList[o]
        newList[o] = newList[t]
        newList[t] = m
        setInsertList(newList)
    }, [insertList])

    const deleteInsertPlugin = useCallback((insertId) => {
        const newList = [...insertList]
        for (let i = 0; i < newList.length; i++) {
            if (newList[i].insertId === insertId) {
                newList.splice(i, 1)
                break
            }
        }
        if (insertId === _currentInsertPlugin.current.insertId) {
            _currentInsertPlugin.current = {}
            setCurrentPlugin({})
        }
        setInsertList(newList)
    }, [insertList, currentPlugin])

    return (
        <InsertContext.Provider
            value={{
                insertList,
                insert,
                currentPlugin,
                init: () => {
                    initInsertProvider()
                },
                setCurrentPlugin: (plugin) => {
                    _currentInsertPlugin.current = plugin
                    setCurrentPlugin(plugin)
                },
                changeCurrentPluginRect: handleChangeCurrentPluginRect,
                updateCurrentPluginProps: handleUpdatePluginProps,
                exchangePluginOrder,
                deleteInsertPlugin,
                findTargetByType: (type) => {
                    let result = null
                    insertList.forEach((item, index) => {
                        if (item.type === type) {
                            result = item
                        }
                    })
                    return result
                }
            }}
        >
            {children}
        </InsertContext.Provider>
    )
}

export default InsertProvider